/**
 * Used internally to parse fields returned by the ArcGIS component to a more readable format.
 *
 * @param {any} address - The raw address object returned from ArcGIS.
 * @param {{ x: number, y: number }} [location] - Optional location object containing x (longitude) and y (latitude) coordinates.
 * @param {number} location.x - The longitude value.
 * @param {number} location.y - The latitude value.
 * @returns {Address | undefined} A formatted Address object or `undefined` if parsing fails.
 */
export function getAddressFieldsInternal(address, location) {
    const newAddress = {};
    // Reverse geocoding doesn't return a place name. Instead it returns either a Address or ShortLabel field
    if (address === null || address === void 0 ? void 0 : address.Address) {
        newAddress.placeName = address.Address;
    }
    if (address === null || address === void 0 ? void 0 : address.PlaceName) {
        newAddress.placeName = address.PlaceName;
    }
    if (address === null || address === void 0 ? void 0 : address.StAddr) {
        newAddress.streetName = address.StAddr;
    }
    if (address === null || address === void 0 ? void 0 : address.City) {
        newAddress.city = address.City;
    }
    if (address === null || address === void 0 ? void 0 : address.RegionAbbr) {
        newAddress.state = address.RegionAbbr;
    }
    if (address === null || address === void 0 ? void 0 : address.Subregion) {
        newAddress.county = address.Subregion;
    }
    if (address === null || address === void 0 ? void 0 : address.Postal) {
        newAddress.postalCode = address.Postal;
    }
    if (location) {
        newAddress.location = {
            latitude: location.y,
            longitude: location.x,
        };
    }
    return newAddress;
}
